export default {
    'thank-you': {
        'caption': 'Thank you for your purchase.',
        'text': `In the next few moments, you will receive and confirmation email.
        <br/>If not, please <!-- take note of this reference: 000000
        <br/>and --> contact us immediately.`,
        'main': 'Main page',
        'contact': 'Contact',
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/site/thankYou/i18n/en.js